import apiWrapper from 'Helpers/apiWrapper'

const endpoints = (baseURL => {
  return {
    beFeatureToggleGetFlagsToShow: () => `${baseURL}/api/features/show`
  }
})(process.env.BEFEATURETOGGLE_URL)

export const beFeatureToggleGetFlagsToShow = features => {
  const url = endpoints.beFeatureToggleGetFlagsToShow()

  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify({ Features: features })
  })
    .then(res => res.data)
    .catch(e => {
      return { Features: [] }
    })
}
